import React from 'react';
import { SmartTagsWysiwygLayoutProps } from 'ui-builder';
import ShadcnQuillWysiwygLayout from '../../../form/input/layout/ShadcnQuillWysiwygLayout';
import HowToUseSmartTagsLink from '../../../form/HowToUseSmartTagsLink';
import useSmartTagsMentionModule from './useSmartTagsMentionModule';

import './SmartTagsWysiwygLayout.scss';

export default function ShadcnSmartTagsWysiwygLayout(props: SmartTagsWysiwygLayoutProps) {
  const { modules, quillRef } = useSmartTagsMentionModule(props);

  const afterLabel = !props.hideHowToUseLink
    ? <HowToUseSmartTagsLink />
    : undefined;

  return (
    <ShadcnQuillWysiwygLayout
      {...props}
      afterLabelElement={afterLabel}
      modules={modules}
      quillRef={quillRef}
    />
  );
}
